angular.module("practicesCustomer.components", []).component("practicesCustomer", {
    templateUrl: "ng/components/riskCourse/practicesCustomer/practicesCustomer.view.html",
    bindings: {
        model: "=",
        preventiviAccettati: "=",
        importoPreventiviAccettati: "=",
        contrattiPervAttivi: "=",
        importoContrattiPervAttivi: "=",
        contrattiStipulati: "=",
        importoContrattiStipulati: "=",
        totale: "=",
        importoTotale: "=",
        importoPrevAttuale: "="
    },
    controllerAs: "practicesCustomerCtrl",
    controller: function PracticesCustomer() {
        var self = this;

        self.$onInit = function () {
            console.log("model practicesCustomer", self.model);
        };
    }
});